import { render, staticRenderFns } from "./CustomTableColumn.vue?vue&type=template&id=1caa45e1&scoped=true"
import script from "./CustomTableColumn.vue?vue&type=script&lang=js"
export * from "./CustomTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa45e1",
  null
  
)

export default component.exports